import { render, staticRenderFns } from "./JobStatDriversAndVehicles.vue?vue&type=template&id=3d44c293&scoped=true&"
import script from "./JobStatDriversAndVehicles.vue?vue&type=script&lang=js&"
export * from "./JobStatDriversAndVehicles.vue?vue&type=script&lang=js&"
import style0 from "./JobStatDriversAndVehicles.vue?vue&type=style&index=0&id=3d44c293&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d44c293",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSpacer})
